import {Map, List} from 'immutable';

import {myRemoveEntities, myRemoveEntitiesBySport} from './utils';

import {LIVE_INIT, LIVE_UPDATE, TIMETABLE_INIT, TIMETABLE_UPDATE} from 'sagas/actions';

import * as LiveActions from 'actions/Live';
import * as LineActions from 'actions/Line';
import * as TimeTableActions from 'actions/Timetable';
import * as FavouritesActions from 'actions/Favourites';
import * as MatchResultActions from 'actions/MatchResults';
import * as StakeOfTheDayActions from 'actions/StakeOfTheDay';
import * as PopularActions from 'actions/Popular';

import * as FavouriteState from 'constants/FavouriteState';

export default function (leagues, action) {
    switch (action.type) {
        case LiveActions.CLEAR_LIVE:
        case LineActions.CLEAR_LINE:
        case TimeTableActions.CLEAR_TIME_TABLE:
            return Map();

        case LIVE_INIT.SUCCESS:
        case TIMETABLE_INIT.SUCCESS:
        case LineActions.SUCCESS_REQUEST_LINE_HEADERS:
        case LineActions.SUCCESS_REQUEST_SPORT_LINE_HEADERS:
        case LineActions.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS:
        case MatchResultActions.SUCCESS_FETCH_MATCH_RESULTS:
        case StakeOfTheDayActions.SUCCESS_GET_STAKE_OF_THE_DAY:
        case PopularActions.SUCCESS_GET_POPULAR_MATCHES:
            return init(Map(), action.data);

        case LIVE_UPDATE.SUCCESS:
        case TIMETABLE_UPDATE.SUCCESS:
            return update(leagues, action.data);

        case FavouritesActions.TOGGLE_FAVOURITE_SPORT:
            return toggleSportFavouriteLeagues(leagues, action.data);

        case FavouritesActions.TOGGLE_FAVOURITE_LEAGUE:
            return toggleFavouriteLeague(leagues, action.data);

        case FavouritesActions.TOGGLE_FAVOURITE_MATCH:
            return toggleFavouriteMatchLeague(leagues, action.data);
    }

    return leagues;
}

function init(leagues, data) {
    if (data.leagues !== undefined) {
        leagues = addLeagues(leagues, data.leagues.add);
    }
    if (data.events !== undefined) {
        leagues = addLeagueMatches(leagues, data.events.add);
    }

    return leagues;
}

function update(leagues, data) {
    if (data.sports !== undefined && data.sports.remove !== undefined) {
        //leagues = removeEntities(leagues, 'sportId', data.sports.remove);
        leagues = myRemoveEntitiesBySport(leagues, 'sportId', data.sports.remove);
    }

    if (data.leagues !== undefined) {
        //leagues = removeEntities(leagues, 'id', data.leagues.remove);
        leagues = myRemoveEntities(leagues, 'id', data.leagues.remove);
        leagues = addLeagues(leagues, data.leagues.add);
        leagues = changeLeagues(leagues, data.leagues.change);
    }

    if (data.events !== undefined) {
        //leagues = removeLeagueMatches(leagues, data.events.remove);
        leagues = myRemoveLeagueMatches(leagues, data.events.remove);
        leagues = leagueFavouriteStateChangeOnMatchesRemove(leagues, data.events.remove);
        leagues = addLeagueMatches(leagues, data.events.add);
        leagues = leagueFavouriteStateChangeOnMatchesAdd(leagues, data.events.add);
    }

    return leagues;
}

function addLeagues(leagues, addedLeagues) {
    if (addedLeagues === undefined) {
        return leagues;
    }

    return leagues.withMutations(l => {
        for (let i = 0; i < addedLeagues.length; i++) {
            let league = Map(addedLeagues[i]);
            league = league.set('matches', List());
            league = league.set('favouriteState', FavouriteState.NONE);
            league = league.set('favouriteMatches', List());

            l.set(league.get('id'), league);
        }
    });
}

function changeLeagues(leagues, changedLeagues) {
    if (changedLeagues === undefined) {
        return leagues;
    }

    for (let i = 0; i < changedLeagues.length; i++) {
        const league = changedLeagues[i];

        leagues = leagues.updateIn([league.id, 'name'], () => {return league.name});
        leagues = leagues.updateIn([league.id, 'priority'], () => {return league.priority});
    }

    return leagues;
}

function addLeagueMatches(leagues, addMatches) {
    if (addMatches === undefined) {
        return leagues;
    }

    for (let i = 0; i < addMatches.length; i++) {
        (function (leagueId, matchId) {
            leagues = leagues.updateIn([leagueId, 'matches'], m => m.push(matchId));
        })(addMatches[i].leagueId, addMatches[i].id);
    }

    return leagues;
}

function myRemoveLeagueMatches(leagues, removeMatches) {
    if (removeMatches === undefined) {
        return leagues;
    }

    for (let i = 0; i < removeMatches.length; i++) {
        const matchId = removeMatches[i].id;
        const leagueId = removeMatches[i].leagueId;

        let matches = leagues.getIn([leagueId, 'matches']);
        if (matches !== undefined) {
            matches = matches.filter(mId => (mId != matchId));
        }
        leagues = leagues.setIn([leagueId, 'matches'], matches);

        let favouriteMatches = leagues.getIn([leagueId, 'favouriteMatches']);
        if (favouriteMatches !== undefined) {
            favouriteMatches = favouriteMatches.filter(mId => (mId != matchId));
        }
        leagues = leagues.setIn([leagueId, 'favouriteMatches'], favouriteMatches);
    }

    return leagues;
}

function toggleFavouriteLeague(leagues, league) {
    return leagues.updateIn([league.get('id')], l => {
        const favouriteState = l.get('favouriteState') === FavouriteState.FULL
            ? FavouriteState.NONE
            : FavouriteState.FULL;

        l = l.set('favouriteState', favouriteState);

        if (favouriteState === FavouriteState.FULL) {
            return l.set('favouriteMatches', l.get('matches'));
        } else {
            return l.set('favouriteMatches', List());
        }
    });
}

function toggleSportFavouriteLeagues(leagues, sport) {
    const sportLeagues = leagues.valueSeq()
        .filter(l => l.get('sportId') === sport.get('id'))
        .map(l => l.get('id'))
        .toArray();

    const favouriteState = sport.get('favouriteState') === FavouriteState.FULL
        ? FavouriteState.NONE
        : FavouriteState.FULL;

    for (let i = 0; i < sportLeagues.length; i++) {
        leagues = leagues.updateIn([sportLeagues[i]], l => {
            l = l.set('favouriteState', favouriteState);

            if (favouriteState === FavouriteState.FULL) {
                return l.set('favouriteMatches', l.get('matches'));
            } else {
                return l.set('favouriteMatches', List());
            }
        });
    }

    return leagues;
}

function toggleFavouriteMatchLeague(leagues, match) {
    const leagueId = match.get('leagueId');
    const matchFavouriteState = match.get('favouriteState');

    const matchId = match.get('id');

    if (matchFavouriteState === FavouriteState.NONE) {
        leagues = leagues.updateIn([leagueId, 'favouriteMatches'], m => m.push(matchId));
    } else {
        leagues = leagues.updateIn([leagueId, 'favouriteMatches'], m => {
            const index = m.indexOf(matchId);
            return m.remove(index);
        });
    }

    let leagueFavouriteState = FavouriteState.FULL;

    const leagueMatches = leagues.getIn([leagueId, 'matches']);
    const leagueFavouriteMatches = leagues.getIn([leagueId, 'favouriteMatches']);

    if (leagueFavouriteMatches.size === 0) {
        leagueFavouriteState = FavouriteState.NONE;
    } else if (leagueFavouriteMatches.size < leagueMatches.size) {
        leagueFavouriteState = FavouriteState.PARTIAL;
    }

    return leagues.updateIn([leagueId], l => {
        return l.set('favouriteState', leagueFavouriteState);
    });
}

function leagueFavouriteStateChangeOnMatchesAdd(leagues, newMatches) {
    if (newMatches === undefined) {
        return leagues;
    }

    for (let i = 0; i < newMatches.length; i++) {
        const match = newMatches[i];
        const leagueId = match.leagueId;

        const leagueFavouriteState = leagues.getIn([leagueId, 'favouriteState']);

        leagues = leagues.updateIn([leagueId], s => {
            return s.set('favouriteState', leagueFavouriteState === FavouriteState.FULL
                ? FavouriteState.PARTIAL
                : leagueFavouriteState);
        });
    }

    return leagues;
}

function leagueFavouriteStateChangeOnMatchesRemove(leagues, removeMatches) {
    if (removeMatches === undefined) {
        return leagues;
    }

    for (let i = 0; i < removeMatches.length; i++) {
        const match = removeMatches[i];
        const leagueId = match.leagueId;

        const leagueMatches = leagues.getIn([leagueId, 'matches']);
        const leagueFavouriteMatches = leagues.getIn([leagueId, 'favouriteMatches']);

        let leagueFavouriteState = FavouriteState.FULL;

        if (leagueFavouriteMatches.size === 0) {
            leagueFavouriteState = FavouriteState.NONE;
        } else if (leagueFavouriteMatches.size < leagueMatches.size) {
            leagueFavouriteState = FavouriteState.PARTIAL;
        }

        leagues = leagues.updateIn([leagueId], s => {
            return s.set('favouriteState', leagueFavouriteState);
        });
    }

    return leagues;
}



// WEBPACK FOOTER //
// ./js/shared/reducers/entities/leaguesReducer.js